import React from 'react';

import fromAnyToBool from 'utils/converters/fromAnyToBool.util';

const hasReactChildren = children => fromAnyToBool(React.Children.count(children));

// noinspection JSUnusedGlobalSymbols
export default hasReactChildren;
